import { useCallback } from 'react';
import { useLazyGetDomainOrderQuery } from '../../../domainsApi';
import { useSequentialPolling } from '../../../hooks';
import type { OrderState } from '../utils';

interface UseOrderPollingParams {
  payOrderId: string;
  orderState: OrderState;
  enabled: boolean;
}

export const useOrderPolling = ({
  payOrderId,
  orderState,
  enabled,
}: UseOrderPollingParams): void => {
  const [fetchOrder] = useLazyGetDomainOrderQuery();

  const fetchFn = useCallback(async () => {
    await fetchOrder(payOrderId).unwrap();
  }, [fetchOrder, payOrderId]);

  const shouldPoll = Boolean(payOrderId) && orderState === 'pending';

  useSequentialPolling({
    fetchFn,
    shouldPoll,
    enabled,
    skipFirstImmediate: true,
  });
};
